import { useMemo, useReducer } from 'react'

import { BreadcrumbsContext, NavigationBreadcrumb } from './use-breadcrumbs-context'

export const BreadcrumbsProvider = ({ children }) => {
  const [breadcrumbs, dispatchBreadcrumbs] = useReducer(breadcrumbsReducer, [])

  const value = useMemo(() => ({ breadcrumbs, dispatchBreadcrumbs }), [breadcrumbs, dispatchBreadcrumbs])

  return <BreadcrumbsContext.Provider value={value}>{children}</BreadcrumbsContext.Provider>
}

function breadcrumbsReducer(
  state: NavigationBreadcrumb[],
  action: { type: 'add' | 'remove'; value: NavigationBreadcrumb },
) {
  switch (action.type) {
    case 'add':
      return [...state, action.value]
    case 'remove':
      return state.filter((val) => val !== action.value)
  }
}
